/* eslint-disable no-unused-vars */
/* eslint-disable capitalized-comments */
// import * as Sentry from "@sentry/react";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line arrow-body-style
const ErrorFallback = ({ error, resetErrorBoundary }) => {
	// Sentry.captureException(`From ErrorBoundary Fallback: ${error}`);

	return (
		<div role="alert" style={{ marginTop: "70px" }}>
			<p className="text-danger">Oops, something went wrong! Try refreshing the page or contact technical support.</p>
			<Button onClick={resetErrorBoundary} variant="danger">Please try again!</Button>
		</div>
	);
};

ErrorFallback.propTypes = {
	error: PropTypes.shape({ message: PropTypes.string }).isRequired,
	resetErrorBoundary: PropTypes.func.isRequired
};

export default ErrorFallback;
